module.exports = __webpack_public_path__ + "img/VivaVegasLogo.4dbf3f60.png";